import Dropdown from 'react-bootstrap/Dropdown';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faClose, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useNotifications } from '@/hooks';
import FrontendHttpClient from '@/utils/http-handler/frontend-http-client';
import styles from './styles.module.scss';
import cx from 'clsx';
import { useMemo, useState } from 'react';

import { useRouter } from 'next/router';

const NotificationBell = () => {
  const { notifications, mutate } = useNotifications();

  const [isLoading, setIsLoading] = useState(false);

  const router = useRouter();
  const prominentNotification = useMemo(() => {
    return notifications?.records?.find(record => record?.type === 'broadcast');
  }, [notifications]);

  const handleNotificationClick = async record => {
    if (!record) {
      return;
    }

    FrontendHttpClient.get(`/api/v2/notifications/${record.id}/read`).then(() =>
      mutate()
    );

    if (record.href) {
      router.push(record.href);
    }
  };

  const handleDeleteNoticationClick = async record => {
    if (!record) {
      return;
    }

    setIsLoading(true);
    await FrontendHttpClient.delete(
      `/api/v2/notifications/${record.id}/delete`
    );

    mutate();
    setIsLoading(false);
  };

  if (!notifications?.records?.length) {
    return <></>;
  }

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          as="div"
          className={cx(
            styles.bellIcon,
            prominentNotification && styles.blinkingBell
          )}
          id="dropdown-basic"
        >
          <FontAwesomeIcon icon={faBell} color="gray" size="xl" />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {notifications?.records?.map(record => (
            <div
              className={cx(
                styles.notificationItem,
                (!record.read || record.isPendingAction) &&
                  styles.unreadNotification
              )}
              key={record.id}
            >
              <div>
                <button
                  style={{
                    border: 'none',
                    background: 'transparent',
                    textAlign: 'left',
                  }}
                  onClick={() => handleNotificationClick(record)}
                >
                  {record.message}
                </button>
              </div>
              {!record?.isPendingAction && (
                <FontAwesomeIcon
                  onClick={() => handleDeleteNoticationClick(record)}
                  icon={isLoading ? faSpinner : faClose}
                  color="gray"
                  size="lg"
                  spin={isLoading}
                />
              )}
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default NotificationBell;
